<template>
  <div class="tabs">
    <ul>
      <li v-for="tab in tabs" :key="tab.id" v-bind:class="{'active': (tabActive == tab.id)}">
        <a href="#" @click.prevent="onClick(tab)">{{ tab.name }} <span v-if="tab.nameExtra">({{ tab.nameExtra }})</span></a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tabs',
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
    active: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tabActive: '',
    };
  },
  created() {
    if (this.active) {
      this.tabActive = this.active;
    } else if (this.$route.query.tab) {
      this.tabActive = this.$route.query.tab;
    }
  },
  methods: {
    onClick(tab) {
      this.tabActive = tab.id;
      this.$router.push(tab.url);
      this.$emit('on-click-tab', tab);
    },
  },
};
</script>

<style scoped>
.tabs {
  border-bottom: 1px solid #ececec;
  margin-bottom: 30px;
  padding: 0;
}
.tabs ul {
  list-style: none;
  margin: 0;
  padding: 0;
  clear: both;
}
.tabs li {
  display: inline-block;
  margin: 0;
  padding: 0px 10px 0px 0px;
}
.tabs li:last-child {
  padding-right: 0;
}
.tabs li:last-child {
    padding-right: 0;
}
.tabs li a {
  display: block;
  color: #363636;
  text-decoration: none;
  font-weight: 700;
  padding: 0px 8px 6px 8px;
}
.tabs li a:hover {
  text-decoration: none;
  color: #858585;
}
.tabs li a span {
  color: #858585;
}
.tabs .active a {
  color: #2ab363;
  border-bottom: 3px solid #2ab363;
}
.tabs .active a span {
  color: #2ab363;
}
.tabs .active a:hover {
  color: #59c485;
  border-bottom: 3px solid #59c485;
}

@media (min-width: 992px) {

.tabs li {
  padding-right: 20px;
}

}
</style>
